export function isMp4Url(url) {
  const u = String(url || "").split("?")[0].split("#")[0].toLowerCase();
  return u.endsWith(".mp4");
}
